import React, { PropTypes } from "react"
import { FilterIcon } from './FilterIcon'
import { iconMap } from './icon-map'
import { translate } from "./translate"

const ElementRow = ({ title, data }) => (
    <div className="info">
        <div className="key">{title}</div>
        <p>{data}</p>
    </div>
)
ElementRow.propTypes = {
    title: PropTypes.string,
    data: PropTypes.string,
}

export const EasinsureContractsListItem = ({ contract, onLinkClicked }) => (
    <div className="element" onClick={onLinkClicked}>
        <FilterIcon iconValue={iconMap[contract.brancheCode]}/>
        <div className="elementData">
            <ElementRow title={translate('risk')} data={contract.mainRisk}/>
            <ElementRow title={translate('policy')} data={contract.contractNumber}/>
            <ElementRow title={translate('company')} data={contract.insuranceCompany}/>
            <ElementRow title={translate('status')} data={contract.contractState}/>
        </div>
    </div>
)
EasinsureContractsListItem.propTypes = {
    contract: PropTypes.object,
    onLinkClicked: PropTypes.func,
}

// const contractElementRow = (key, data, isPhone = false) => {
//     return (
//         <div className={cs(styles.info, isPhone && styles.infoPhone)}>
//             <div className={cs(styles.key, isPhone && styles.keyRight)}>
//                 {key}
//             </div>
//             <p>{data}</p>
//         </div>
//     );
// };

// {!isPhone ? (
//     <div className={cs(styles.elementData)}>
//         <div className={cs(styles.dataColumn)}>
//             {contractElementRow(_("risk"), contract.mainRisk)}
//             {contractElementRow(
//                 _("policy"),
//                 contract.contractNumber
//             )}
//         </div>
//         <div className={styles.dataColumn}>
//             {contractElementRow(
//                 _("company"),
//                 contract.insuranceCompany
//             )}
//             {contractElementRow(
//                 _("status"),
//                 contract.contractState
//             )}
//         </div>
//     </div>
// ) : (
//     <div
//         className={cs(
//             styles.elementData,
//             isPhone && styles.phoneElementData
//         )}
//     >
//         <div
//             className={cs(
//                 styles.dataColumn,
//                 isPhone && styles.phoneDataColumn
//             )}
//         >
//             {contractElementRow(
//                 _("risk"),
//                 contract.mainRisk,
//                 isPhone
//             )}
//             {contractElementRow(
//                 _("policy"),
//                 contract.contractNumber,
//                 isPhone
//             )}
//             {contractElementRow(
//                 _("company"),
//                 contract.insuranceCompany,
//                 isPhone
//             )}
//             {contractElementRow(
//                 _("status"),
//                 contract.contractState,
//                 isPhone
//             )}
//         </div>
//     </div>
// )}



// WEBPACK FOOTER //
// ./components/easinsure/contracts/EasinsureContractsListItem.jsx